export const VALIDATE = {
  EMAIL_MAX: 255,
  NAME_MIN: 4,
  NAME_MAX: 8,
  PASSWORD_MIN: 6,
  PASSWORD_MAX: 8,
  INQUIRY_NAME_MAX: 20,
  INQUIRY_MAX: 16384,
};
